import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface ProductImage {
    file_idx: number;
    file_name: string;
    original_name: string;
}

export interface ProductCategory {
    product_category_idx: number;
    category_name: string;
    union_option: boolean;
}

export interface ProductData {
    product_idx: number;
    product_image: ProductImage;
    product_category: ProductCategory;
    product_name: string;
    product_amount: number;
    product_code: string;
    product_code_name: string;
}

interface GetProductResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: ProductData[];
}

export const useGetOrderProduct = (page: number, search?: string, searchtxt?: string): UseQueryResult<GetProductResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetProductResponse, Error>({
        queryKey: ["getProductList", page, search, searchtxt],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_product}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    page,
                    search,
                    searchtxt,
                    field: "product_category",
                    direction: "ASC",
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
